import { ContactUs } from "./ContactUs";
import { useContattiQuery } from "../generated/graphql";
export function ContactUsStandard() {
  const { data } = useContattiQuery();
  return (
    <ContactUs
      text={data?.contatti?.testoIscriviti || ""}
      url="https://thepadelresort.us14.list-manage.com/subscribe/post?u=fc95bebb5e17453f8c556fef9&amp;id=1dbc49271c&amp;v_id=4825&amp;f_id=006899e5f0"
    />
  );
}
